module.exports = __webpack_public_path__ + "img/serviceState1.7f46b19d.svg";